module.exports = __webpack_public_path__ + "assets/img/zhangjie.dc69858f.png";